// **************************************************
// Side Bar toggle
// **************************************************

const sideBarEleTitles = document.querySelectorAll('.side-bar__button');

attachEvent('.side-bar__button', 'click', (ev) => {
  const parentElem = ev.target.closest('.side-bar__item');
  const sidebarDropdown = parentElem.querySelector('.side-bar__item-dropdown');
  parentElem.classList.toggle('is-open');
  slideToggle(sidebarDropdown, 300, 'block');
});
